import React, {useEffect, useState} from 'react';
import GraphicUtils from "../../../../../utils/graphic-utils.js";
import ReportUtils from "../../../../../utils/report-utils.js";

const NeighborhoodsContent = ({data, boName}) => {
    useEffect(() => {
        const values = [];
        const labels = [];

        data.neighborhoodsWithMoreBos.forEach((el) => {
            labels.push(ReportUtils.formatText(el.address));
            values.push(el.amount);
        });

        GraphicUtils.barChart("neighborhoodsWithMoreBos", values.slice(0, 10), labels.slice(0, 10), true);
        ReportUtils.createExportableTable(labels, values, `${boName} por bairro`)
    }, [data]);

    return (
        <>
            <div id="address-table">
                <div className="chart mt-3">
                    <span className="chart-title">
                        {data.boName} por bairro {data.neighborhoodsWithMoreBos.length >= 10 ? ' (TOP 10)' : ''}
                    </span>
                    <div id="neighborhoodsWithMoreBos"></div>
                </div>
            </div>

            <div className="chart-divisor print-hide"></div>
        </>
    );
};

export default NeighborhoodsContent;